<template>
  <div class="flex items-center  hover:text-primary">
    {{ params.value  | moment("MMM D YYYY, h:mm a") }}
  </div>
</template>

<script>
export default {
  name: 'CellRendererUpdated'
}
</script>